import { ManageBiography } from "apiEndPoints";
import APIrequest from "services/axios";
import { logger } from "utils";

export const ManageBiographyServices = {
  getAllBioGraphy: async (queryParams) => {
    try {
      const payload = {
        ...ManageBiography.getBiographies,
        queryParams,
      };

      return await APIrequest(payload);
    } catch (err) {
      logger(err);
      throw err;
    }
  },
  reportedBioGraphyServices: async (queryParams) => {
    try {
      const payload = {
        ...ManageBiography.reportedBiographies,
        queryParams,
      };

      return await APIrequest(payload);
    } catch (err) {
      logger(err);
      throw err;
    }
  },
  updateBioGraphyStatusServices: async (memorialId, bodyData) => {
    try {
      const payload = {
        ...ManageBiography.updateBiographyStatus(memorialId),
        bodyData,
      };

      return await APIrequest(payload);
    } catch (err) {
      logger(err);
      throw err;
    }
  },
};
